/**
 * The pure arrow-key arithmetic shared by search-and-pick lists (the chart library panel, the
 * sidebar chart search).
 *
 * Only the clamp/step is shared on purpose. Each list's Enter handling is entangled with its own
 * concerns — the library forwards Ctrl/Shift to open in a window, the sidebar search scrolls the
 * report page — and folding those together would mean reshaping working components around a hook's
 * lifecycle. The index arithmetic is the part that would actually drift between copies.
 */

/** Next highlight index for an arrow key, or null when the key is not list navigation. */
export function nextHighlightForKey(
  key: string,
  current: number,
  length: number
): number | null {
  if (length <= 0) {return null;}
  if (key === "ArrowDown") {
    // From -1 ("nothing highlighted") this lands on 0, which is what lets a list open with no
    // preselection and still respond to a single press.
    return Math.min(current + 1, length - 1);
  }
  if (key === "ArrowUp") {
    return Math.max(current - 1, 0);
  }
  return null;
}

/** Keep a highlight inside a list that may have shrunk under it. -1 (no selection) is preserved. */
export function clampHighlight(highlight: number, length: number): number {
  if (length <= 0) {return -1;}
  if (highlight < 0) {return -1;}
  return Math.min(highlight, length - 1);
}
